import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTeamInfo } from '../../team-id-context';
import { fillPlaceholders, paths } from '../../routing';

/**
 * Contact Fields settings page - redirects to Contacts page with manage fields slideout open
 */
const ContactFields = () => {
  const { teamId } = useTeamInfo();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to People > Contacts tab with query param to open manage fields slideout
    const teamPath = fillPlaceholders(paths.team.landing, { teamId });
    navigate(`${teamPath}?tab=contacts&manageFields=true`, { replace: true });
  }, [teamId, navigate]);

  return null;
};

export default ContactFields;
